import styled from 'styled-components'

const Style = styled.div`
  /* width: 592px; */
  /* max-width: 592px; */
  /* display: grid; */
  /* grid-template-rows: 8% 82% 10%; */
`

export default Style
